import { createContext, useContext } from "react";

/**
 * Permissões da sessão que as telas precisam consultar.
 * Começa em `false`: enquanto o /api/me não responde, o botão de excluir fica
 * escondido — mostrar e sumir depois seria pior do que aparecer um instante
 * mais tarde.
 */
const Ctx = createContext(false);

export const PermissoesProvider = Ctx.Provider;

/** Só administradores podem excluir registros (regra do Portal). */
export const usePodeExcluir = () => useContext(Ctx);
